import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const VehicleColumns: TableColumn[] = [
    {
        name: "plateNumber", 
        displayName: "Plate No.", 
        dataType: COLUMN_TYPES.string, 
        isEditable: true, 
        isEditableOnNew: true, 
        styles: {width: '30%'},
        reference: '',
        selectOptions: null
    },
    {
        name: "isTruck", 
        displayName: "is Truck?", 
        dataType: COLUMN_TYPES.bool, 
        isEditable: true, 
        isEditableOnNew: true, 
        styles: {width: '10%'},
        reference: '',
        selectOptions: null
    },
    {
        name: "isActive", 
        displayName: "is Active?", 
        dataType: COLUMN_TYPES.bool, 
        isEditable: true, 
        isEditableOnNew: true, 
        styles: {width: '10%'},
        reference: '',
        selectOptions: null
    },
    {
        name: "createdBy", 
        displayName: "Created By", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {width: '30%'},
        reference: '',
        selectOptions: null
    }
];


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.vehicle.ts